// extracted by mini-css-extract-plugin
module.exports = {"overlay":"StartMediaButton_overlay__WHBn3","button":"StartMediaButton_button__JjGuI","fade-in":"StartMediaButton_fade-in__Odhps"};